// src/components/scenarios/ScenarioList.js
import React from 'react';
import { useScenarios } from '../../context/ScenarioContext';
import { useSettings } from '../../context/SettingsContext';
import SectionHeader from '../common/SectionHeader';
import SectionNavigation from '../common/SectionNavigation';
import ScenarioPanel from './ScenarioPanel';

function ScenarioList({ onNextSection, onPreviousSection, currentSectionIndex, sectionNames }) {
  const { scenarios, addScenario } = useScenarios();
  const { expandedSections } = useSettings();
  
  return (
    <div className="calculator-section">
      <SectionHeader title="Retirement Scenarios" sectionKey="scenarios" />
      
      <div className="scenarios-container">
          {scenarios.map(scenario => (
            <ScenarioPanel key={scenario.id} scenario={scenario} />
          ))}
        </div>

      {/* New footer for action buttons */}
      <div 
        className="scenario-list-actions-footer" 
        style={{
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          marginTop: '24px', // Added margin for spacing from content above
          flexWrap: 'wrap', // Allow wrapping on small screens if buttons are too wide
          gap: '16px' // Add gap for wrapped items
        }}
      >
        <div>
          {scenarios.length < 6 && (
            <button className="add-scenario-btn" onClick={addScenario}>
              + Add Scenario
            </button>
          )}
        </div>

        <SectionNavigation
          onNextSection={onNextSection}
          onPreviousSection={onPreviousSection}
          currentSectionIndex={currentSectionIndex}
          sectionNames={sectionNames}
        />
      </div>
    </div>
  );
}

export default ScenarioList;